import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-snp-detail',
  templateUrl: './snp-detail.component.html',
  styleUrls: ['./snp-detail.component.css']
})
export class SnpDetailComponent {

  snps: any[];
  references: any[];
  selectedReference: any;
  uploadedFiles: any[] = [];

  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private messageService: MessageService)
  {
  }

  ngOnInit() {
    var id : string = this.route.snapshot.paramMap.get("id")!;
    this.getReferences(+id);
  }

  onUpload(event:any) {
    for(let file of event.files) {
        this.uploadedFiles.push(file);
    }

    this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
  }

  getReferences(id: number)
  {
    this.dataService.getSnpsBySample(id).then(data => {
      this.snps = data;
      console.log(this.snps);
      this.dataService.getReferences().then(data => {
        this.references = data.map((s: { name: any; referenceId: any; }) => ({name: s.name, code: s.referenceId}))
        console.log(this.references.filter(x => x.code == this.snps[0].referenceId));
        this.selectedReference = this.references.filter(x => x.code == this.snps[0].referenceId)[0];
      });
    });
  }

  getSnpClass(result: string, reference: string){
    if (result.trim() == reference)
    {
      return "snp-match";
    }
    else
    {
      return "snp-nomatch";
    }
  }

  referenceChange(){
    this.updateSnpReference();
  }

  updateSnpReference()
  {
    var sampleId = this.snps[0].sampleId;
    this.dataService.updateSnpReference(sampleId, this.selectedReference.code).then(data =>
      {
        this.getReferences(sampleId);
      });
  }
  //updateSnpReference
}
